import type { Ref } from 'react';

import { fontStyles } from '@/styles/typography';

import { LABEL_PADDING_VERTICAL } from './constants';
import { ChartTick } from './types';

type ChartLabelsProps = {
  width: number;
  height: number;
  right: number;
  color: string;
  xTicks: ChartTick[];
  yTicks: ChartTick[];
  yLabelsRef: Ref<SVGGElement>;
};

export const ChartLabels = ({
  width,
  height,
  right,
  color,
  xTicks,
  yTicks,
  yLabelsRef,
}: ChartLabelsProps) => (
  <>
    <g ref={yLabelsRef}>
      {yTicks.map(({ position, label }) => (
        <text
          key={`value-${position}`}
          x={width - right + LABEL_PADDING_VERTICAL}
          y={position}
          dominantBaseline="middle"
          className={fontStyles({ variant: 'CAPTION' })}
          fill={color}
        >
          {label}
        </text>
      ))}
    </g>
    {xTicks.map(({ position, label, anchor }, index) => (
      <text
        key={`x-${position}`}
        x={position}
        y={height - 6}
        className={fontStyles({ variant: 'CAPTION' })}
        fill={color}
        textAnchor={
          anchor ?? (index === 0 ? 'start' : index === xTicks.length - 1 ? 'end' : 'middle')
        }
      >
        {label}
      </text>
    ))}
  </>
);
